import React from 'react';
import { useHistory } from "react-router-dom";
import {Box, Grid, Button, Link} from '@material-ui/core';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import {MetaTags} from 'react-meta-tags';
import {API_URL} from '../utils/EnvVars';
import Cookies from 'js-cookie';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  export default function Execute() {	
	let history = useHistory();
	const [userId, setUserId] = React.useState("");
	const [showAlert, setShowAlert] = React.useState(false);
	const [submitResponse, setSubmitResponse] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	
	var vertical='top',horizontal='center';

	function hideAlert(){
		setShowAlert(false);
	}

	function submit(){
		
		if(!userId){
			setShowAlert(true);
			setAlertMessage("Enter email or mobile.");
			document.getElementById("passwordinputid").focus();			
			return false;
		}else{
			document.getElementById('waitloginbtnid').style.display='';
			document.getElementById('loginbtnid').style.display='none';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  
			const data = new FormData();
			data.append('userId', userId);
			axios.post(API_URL+'/app/create-forget-password-token', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response);
				if(response && response.data && response.data.responseTxt==="success"){					
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';

					Cookies.set('resetPasswordToken', JSON.stringify(response.data.obj) );

					//setSubmitResponse(true);
					// setEmailIdSent(response.data.emailId);
					// setMobileSent(response.data.mobile);
					history.push('resetpassword');				
				}else if(response.data.responseTxt=="InvalidUserId"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Sorry, We could not find your detail in our record. Enter correct detail.");			
					return false;	
				}else{
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Error somewhere, Try after sometime.");			
					return false;
				}
			})
			.catch((error) => {
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})
		}  
	}
	
	function onEnter(event){
		if(event.key === 'Enter'){
			submit();
		}
	}

	  
		return (
			<div> 
				<MetaTags>
            		<title>Forgot Password</title>
            		<meta name="description" content="Forgot Password" />
          		</MetaTags>
				
				
				<Box className="loginBGImg" style={{backgroundImage:"url('"+process.env.PUBLIC_URL+"/student_login_bg.jpg')", backgroundPosition: 'center', height: '100vh', overflow: 'hidden'}}>
				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Box>
						<Grid container style={{justifyContent: 'center'}} spacing={2}>
							<Grid item className="dhslogin animate-zoom" md={6} xs={12}>

								<Grid className="flex-container loginbox">								
									<Grid md={12} xs={12}>
									<img src={process.env.PUBLIC_URL+"/ease_to_learn_logo.png"} style={{height:80,marginTop:20,marginBottom:20}}  />
									</Grid>
									<Grid md={12} xs={12}>
										{submitResponse?<span style={{color:'#dea338',fontSize:16,fontWeight:'bold',lineHeight:2}}>We have sent you reset password url. Kindly check your email</span>:
										<>
											<div className='loginLabel' >Email or Mobile</div>
											<TextField
												onKeyPress={(event)=>{onEnter(event)}}
												onChange={event => setUserId(event.target.value)}
												color="warning"
												id="passwordinputid"
												placeholder='Enter Email or Mobile'
												style={{backgroundColor:'#FFF', borderRadius: 5}}
												size="small"
												fullWidth	
												variant="outlined"											
												/>
										</>
										}
									</Grid>
									<Grid md={12} xs={12}>
										<Link href="/student" className="loginfrgot" >Back to login</Link>
									</Grid>
									
									{!submitResponse?
									<Grid md={12} xs={12}>
										<Button id="loginbtnid" onClick={()=>{submit()}} className="loginbtn" variant="contained">SUBMIT</Button>
										<LoadingButton 
											className="loginbtn"
											loading
											loadingPosition="start"											
											variant="outlined"
											color="secondary"
											id="waitloginbtnid" 
											style={{textTransform: 'none',display:'none'}}
										>
											Wait...
										</LoadingButton>
									</Grid>
									:null}
								
								</Grid>
							</Grid>
						</Grid>
				</Box>




				</Box>
				
			</div>
		);
 
}